import React from "react";

/**
 * Who makes this, and what a customer's bank will call it.
 *
 * Trackadillo is a PXLPLZ product, and that gets said wherever someone is
 * about to pay or has just paid - not only as a disclosure, but because a
 * card statement showing a name the customer doesn't recognise is how
 * chargebacks start. The renewal reads PXLPLZ, so PXLPLZ has to appear
 * somewhere they've already seen it.
 *
 * One module so the name, the wording and the logo are defined once rather
 * than copied across the landing, sign-up and thank-you pages.
 */

export const PRODUCT_NAME = "Trackadillo";
export const PARENT_COMPANY = "PXLPLZ";

// To use the real logo: drop the file in src/pages/img/ (e.g. pxlplz.svg),
// import it here, and set this to it. ParentMark below switches from the
// text wordmark to an <img> on its own, and every page that uses it picks
// the change up - nothing else needs touching.
export const PARENT_LOGO = null;

/** The parent company's name, as a logo once there is one and text until then. */
export const ParentMark = ({className}) => (
    PARENT_LOGO
        ? <img className={className} src={PARENT_LOGO} alt={PARENT_COMPANY}/>
        : <span className={className}>{PARENT_COMPANY}</span>
);

// The short version, for a form or a confirmation page where a paragraph
// would be in the way. The landing page says it at more length.
export const STATEMENT_NOTE = `${PRODUCT_NAME} is a product of ${PARENT_COMPANY}`
    + `, which is the name that appears on your statement.`;
